export default function (elem) {
  const focusable = elem?.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')[0]
  if (focusable) {
    focusable.focus()
  }
}
